import { ActivatedRoute, Router } from '@angular/router';
import { Component, Injector, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { AddedServiceDataService } from '../../../_dataservices/AddedServiceDataService';
import { AltProductImagePath, AppEventNames, IVA } from "src/app-client/_appCommon/base/Constants";
import { AppClientContext } from "src/app-client/_appCommon/base/AppClientContext";
import { BroadcastManager } from "../../../_appCommon/base/BroadcastManager";
import { CRUDFormControllerBase } from "../../../_appCommon/base/CRUDFormControllerBase";
import { CaseDataService } from '../../../_dataservices/CaseDataService';
import { CaseHistoryDataService } from 'src/app-client/_dataservices/CaseHistoryDataService';
import { CasePurchasedOrdersDataService } from '../../../_dataservices/CasePurchasedOrdersDataService';
import { CaseStageDataService } from "../../../_dataservices/CaseStageDataService";
import { CustomerDataService } from "src/app-client/_dataservices/CustomerDataService";
import { ECOMMERCE_USER_TOKEN } from "src/app/_appCommon/base/Constants";
import { ICaseStage, ItemPrices, OrderPaymentStatus, ProductAdditionalServices, Service, ServiceImage, ServiceType, ServiceTypeLabel, StatusesID } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { PrescriptionDataService } from 'src/app-client/_dataservices/PrescriptionDataService';
import { ProductDataService } from "src/app-client/_dataservices/ProductDataService";
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { ShoppingCartItem } from '../../../_appCommon/base/AppInterfaceAndBaseClasses';
import { StatusDataService } from 'src/app-client/_dataservices/StatusDataService';
import { StatusManagerService } from 'src/app-client/_dataservices/StatusManagerService';
import { SystemServicesDataService } from "src/app-client/_dataservices/security/SystemServicesDataService";
import { UrlQueryDef } from "../../../_appCommon/base/UrlQueryDef";
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';
import { OrderStatus } from 'src/app-admin/_appCommon/base/AppInterfaceAndBaseClasses';
import { OrderHistoryDataService } from 'src/app-client/_dataservices/OrderHistoryDataService';

@Component({
  selector: 'app-client-case-detail',
  templateUrl: './case-detail.component.html',
  styleUrls: ['./case-detail.component.css'],
  providers: [
    CaseDataService,
    CaseHistoryDataService,
    CaseStageDataService,
    CustomerDataService,
    AddedServiceDataService,
    SystemServicesDataService,
    StatusDataService,
    PrescriptionDataService,
    CasePurchasedOrdersDataService,
    OrderHistoryDataService
  ]
})
export class CaseDetailComponent extends CRUDFormControllerBase<CaseDataService>
{
  @ViewChild('caseServicesCatalogDialog') protected caseServicesCatalogDialog: any;
  @ViewChild('confirmManufacturingDialog') protected confirmManufacturingDialog: any;
  @ViewChild('confirmManufacturingSuccessDialog') protected confirmManufacturingSuccessDialog: any;
  @ViewChild('upgradeProductDialog') protected upgradeProductDialog: any;
  @ViewChild('confirmDeleteCurrentCart') protected confirmDeleteCurrentCart: any;
  @ViewChild('confirmCancelOrderDialog') protected confirmCancelOrderDialog: any;
  public unsubscribe: Subject<boolean> = new Subject();

  public caseExpirationDate: Date;
  public caseId: number;
  public currentCustomer: any;
  public currentDate: Date;
  public currentStages = [];
  public hasUnlimitedAligners: boolean = false;
  public hasPendingPayment: boolean = false;
  public isLoading: boolean;
  public isTemplateForProductStore: boolean;
  public loading = false;
  public productName: string;
  public isFinalStatus: boolean = false;
  public showProduct = false;
  public showProductCatalog = false;
  public stagesSelected: any[] = [];

  public upgradeProduct: any;
  public productUpgradeImage: any;
  public products = [];

  public alignersResume: any;
  public casePurchaseorder:any;
  public hasComplexCase: boolean = false;
  public disableUpgradeButton: boolean = true;

  constructor(
    private addedServiceDataService: AddedServiceDataService,
    private caseHistoryDataService: CaseHistoryDataService,
    private caseStageDataService: CaseStageDataService,
    private casePurchasedOrdersDataService: CasePurchasedOrdersDataService,
    private customerDataService: CustomerDataService,
    private injector: Injector,
    private prescriptionDataService: PrescriptionDataService,
    private productDataService: ProductDataService,
    private router: Router,
    private shoppingCartDataService: ShoppingCartDataService,
    private statusDataService: StatusDataService,
    private systemServicesDataService: SystemServicesDataService,
    private orderDataService: OrderDataService,
    private orderHistoryDataService: OrderHistoryDataService,
    protected dataService: CaseDataService,
    protected route: ActivatedRoute,
    public statusManagerService: StatusManagerService,
  )
  {
    super(route, dataService);
  }

  ngAfterViewInit(): void
  {
    
  }

  ngOnInit(): void
  {

    this.route.paramMap.subscribe(params =>
      {
        this.caseId = +params.get('id');
      });

    if(AppClientContext.Instance.customerId){
      this.getCustomerInfo(); 
    }
    else{
      this.getStartupInfo();
    }

    this.isLoading = true;
    this.currentDate = new Date();

    

    this.checkCasePurchasedOrders();

    BroadcastManager.Instance.on(AppEventNames.onChargeDoneServices)
      .pipe(takeUntil(this.shoppingCartDataService.unsubscribeAdditionalServices))
      .subscribe(([response]) =>
      {
        this.caseServicesCatalogDialog.show = false;
        this.onAddServices(response[0], response[1]);
        //Removed by bussines rule 
        //this.getAllCaseStagesToCreateAStage(response[0]);
        this.shoppingCartDataService.unsubscribeAdditionalServices.next(true);
      });

    BroadcastManager.Instance.on(AppEventNames.onUseNewAligners)
      .subscribe(([response]) =>
      {
        //this.currentEntity.usedAligners += response[0];
        this.currentEntity.usedUpperAligners = response[0];
        this.currentEntity.usedLowerAligners = response[1];
        this.update();
      });

    BroadcastManager.Instance.on(AppEventNames.onSelectPurchasedProduct)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([response]) =>
      {
        this.onSetProductToCase(response[0]);
      });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  private checkCasePurchasedOrders(): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.filter = `CaseId eq ${this.caseId}`;
    queryDef.orderby = 'Id desc';
    queryDef.top = 1;
    queryDef.pagingActive = false;
    queryDef.includes = `Order`;

    this.casePurchasedOrdersDataService.get(queryDef)
      .subscribe(response =>
      {
        if (response.rows.length > 0)
        {
          this.hasPendingPayment = (response.rows[0].order.paymentStatus == OrderPaymentStatus.InProcess && response.rows[0].order.status != 2);
          this.casePurchaseorder =response.rows[0];
        }
      }, fail =>
      {

      });
  }

  public onSetProductToCase(orderDetail: any): void
  {
    let body =
    {
      caseId: this.caseId,
      productId: orderDetail.productId,
      orderDetailId: orderDetail.id,
    };

    this.dataService.updateProductId(body)
      .subscribe((response) =>
      {
        this.caseServicesCatalogDialog.show = false;
        this.setSuccessAlert("Paquete agregado al caso satisfactoriamente");

        this.getById(this.caseId);
      }, (fail) =>
      {
        this.setDangerAlert("No se puede asignar el producto porque la orden de pago está cancelada.");
      });
  }

  private getLinkedProduct()
  {
    this.productDataService.getById(this.currentEntity.productId).subscribe((response: any) =>
    {
      this.productName = response.name;
      this.hasUnlimitedAligners = response.hasUnlimitedAligners;
      this.statusManagerService.setProductInfo(response);
    }, (fail: any) =>
    {
      this.setWarningAlert(fail.error.message);
    });
  }

  public buyNewProductClicked()
  {
    this.shoppingCartDataService.caseId = this.caseId;
    this.shoppingCartDataService.casePatientName = this.currentEntity.patientFullName;
    this.productDataService.setProductListCategoryId(1); // Caso = 1
    this.showProductCatalog = !this.showProductCatalog;
    this.isTemplateForProductStore = true;
  }

  public getPurchasedProducts()
  {
    this.showProductCatalog = !this.showProductCatalog;
    this.isTemplateForProductStore = false;
  }

  public onAddServices(services: ShoppingCartItem[], orderId:number): void
  {
    this.shoppingCartDataService.setIsCompleteCreateAddedServices(false);
    let countItems = 0;
    services.forEach( service =>
    {
      let newService: Service = service.item as Service;

      let newServiceAdded = {
        serviceId: newService.serviceType,
        price: newService.itemPrices.price,
        quantity: service.quantity,
        caseId: this.shoppingCartDataService.caseId,
        customerId: this.currentCustomer.id,
        orderId: orderId,
      };

      this.addedServiceDataService.insertAddedService(newServiceAdded)
        .subscribe(response =>
        { 
          countItems++;
          if(countItems == services.length) { this.shoppingCartDataService.setIsCompleteCreateAddedServices(true);}
        }, fail =>
        {
          this.setWarningAlert(fail.errorDetail.error.message);
        });
    });
  }

  public getByValue(map, searchValue)
  {
    for (let [key, value] of map.entries())
    {
      if (value === searchValue)
        return key;
    }
  }

  public getBackCaseList(): void
  {
    this.router.navigate(['/ecommerce/mis-casos']);
  }

  private getCase(): void
  {
    this.getById(this.caseId);
  }

  public override getById(id: number, clearAlert: boolean = true): void
  {
    this.dataService.getCaseFromEcommerce(id, this.getQueryDefForGetById())
      .subscribe((response: any) =>
      {
        this.getAlignersResumeByCase();
        this.checkCasePurchasedOrders()
        this.clearAlert(clearAlert);
        this.getByIdCallback(response);
      },
      (fail) =>
      {
        this.router.navigate(['/ecommerce']);
        this.setDangerAlert(fail.error.errorDetail.message);
      });
  }

  public onChangeStagesSelected(stages: any): void
  {
    this.stagesSelected = stages;
    if(AppClientContext.Instance.customerId){
      this.getCase();
    }
  }

  public orderToManufacture(): void
  {
    let totalNewQuantityAligners = this.currentEntity.usedAligners + this.stagesSelected.map(x => x.alignersQuantity).reduce((previousValue, currentValue) => previousValue + currentValue, 0);

    if (totalNewQuantityAligners > this.currentEntity.purchasedAligners)
    {
      this.setInfoAlert(`No existen suficientes alineadores comprados en el caso (${this.currentEntity.purchasedAligners}) para mandar a fabricar las etapas seleccionadas.`);
      this.confirmManufacturingDialog.show = false;
    }
    else
    {
      BroadcastManager.Instance.broadcast(AppEventNames.OnCheckOrderToManufacture, true);
      this.crudMode = this.CRUDMode_Edit;
      this.currentEntity.usedAligners = totalNewQuantityAligners;
      this.save();
      this.confirmManufacturingDialog.show = false;
      this.confirmManufacturingSuccessDialog.show = true;
    }
  }

  public get getIsCaseExpired(): boolean
  {
    if (!this.currentEntity?.expirationDate)
      return false;

    let caseExpirationDate = new Date(this.currentEntity?.expirationDate);
    return caseExpirationDate.getTime() < this.currentDate.getTime();
  }

  /**
   * Method used when the users tries to open "Agregar servicios"
   * */
  public onOpenAddServices(): void
  {
    if (this.hasPendingPayment)
    {
      this.setInfoAlert("No puedes agregar servicios adicionales, tienes un pago pendiente");
      return;
    }

    this.caseServicesCatalogDialog.show = !this.caseServicesCatalogDialog.show;
  }

  private getCaseHistory(): void
  {
    let queryDef = new UrlQueryDef();

    queryDef.filter = `CaseId eq ${this.currentEntity.id}`;
    queryDef.orderby=`CreatedDate desc`;
    this.caseHistoryDataService.get(queryDef)
      .subscribe((response) =>
      {
        this.isLoading = false;
        this.currentEntity.caseHistory = response.rows;
      }, (fail) =>
      {
        this.setDangerAlert(fail.error.errorDetail.message);
      });
  }

  public getStatusList(): void
  {
    this.statusDataService.get()
      .subscribe(response =>
      {
        this.statusManagerService.setStatusInfo(response.rows);
      });
  }
  // ********************************************************************************
  // #region Method Overrides
  // ********************************************************************************

  protected onGetQueryDefForGetById(queryDef: UrlQueryDef)
  {
    queryDef.params = {};
    queryDef.params['customerId'] = AppClientContext.Instance.customerId;
    super.onGetQueryDefForGetById(queryDef);
  }

  protected onAfterGetById(currentEntity: any) {
    if (!currentEntity) {
      this.getBackCaseList();
    }
  }

  protected getByIdCallback(_currentEntity: any): void
  {
    if (!_currentEntity) {
      this.getBackCaseList();
    }

    this.currentEntity = _currentEntity;

    this.isFinalStatus = this.currentEntity.statusIsFinal;
    AppClientContext.Instance.case = _currentEntity;
    this.statusManagerService.setCurrentCase(this.currentEntity);

    this.getCaseHistory();
    this.getStatusList();

    if (this.currentEntity.productId != null)
    {
      this.getLinkedProduct();
    }

    if(this.currentEntity.isComplexCase){
      this.hasComplexCase = true;
    }
  }

  public distinctCaseHistoryLog(array: any): any[]
  {
    let uniqueObjects = [];
    let beforeElement = null;

    for (let i = 0; i < array.length; i++)
    {
      if (array[i].statusEcommerceDescription !== beforeElement?.statusEcommerceDescription || array[i]?.stageNumber  !== beforeElement?.stageNumber || array[i]?.crudActionType !== beforeElement?.crudActionType)
      {
        uniqueObjects.push(array[i]);
      }
      beforeElement = array[i];
    }

    return uniqueObjects;
  }

  private unique(arr: any, keyProps: any): any
  {
    const kvArray = arr.map(entry =>
    {
      const key = keyProps.map(k => entry[k]).join('|');
      return [key, entry];
    });

    const map = new Map(kvArray);

    return Array.from(map.values());
  }

  protected onAfterUpdate(currentEntity: any): void
  {
    this.currentEntity = currentEntity;
  }

  public update(): void
  {
    this.onBeforeUpdate(this.currentEntity);

    this.dataService.update(this.currentEntity, this.getQueryDefForGetById().getRequestConfig(true))
      .subscribe((response: any) =>
      {
        this.clearAlert();
        let id: number = this.currentEntity.id;

        this.dataService.getById(id, this.getQueryDefForGetById())
          .subscribe((response: any) =>
          {
            this.getByIdCallback(response);

            this.publishCrudOperationCompleted("Registro actualizado");

            this.onAfterUpdate(this.currentEntity);
          });
      },
      (fail) =>
      {
        var outputs = this.CreateErrorMessage(fail.error.failures);
        this.setDangerAlert(fail.error.message + outputs);
      });
  }
  /**
   * Method used to modify the DB
   * */
  public createStage(item: ShoppingCartItem): void
  {
    let lastStage;
    let serviceItem: Service = item.item as Service;

    let currentCaseId = this.shoppingCartDataService.caseId;

    if (this.currentStages.length != 0)
    {
      lastStage = this.currentStages[this.currentStages.length - 1];
    }

    let newStage: ICaseStage =
    {
      caseId: currentCaseId,
      frecuencyDays: 0,
      comments: `Se ha creado la etapa ${lastStage ? lastStage.stageNumber + 1 : 1} con la compra de alineadores adicionales`,
      isManufactured: false,
      stageNumber: lastStage ? lastStage.stageNumber + 1 : 1,
      setupId: serviceItem.idSetup,
      statusId: StatusesID.InProcessOfDischarge,
      upperAligners: 0,
      lowerAligners: 0,
      preSetupUsed: false,
    };

    this.caseStageDataService.insert(newStage, this.getQueryDefEcommerceConfig())
      .subscribe(response =>
      {
        this.setInfoAlert("Setup y etapa creada");

      }, fail =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }
  /**
   * Method used to complete the service: Additional aligners
   * */
  public onCheckServicesAdditionalAligners(shoppingCartResponse: ShoppingCartItem[]): void
  {
    for (let i = 0; i < shoppingCartResponse.length; i++)
    {
      if (shoppingCartResponse[i].item.name == ServiceTypeLabel.get(ServiceType.AditionalAligners))
      {
        this.createStage(shoppingCartResponse[i]);
      }
    }

  }
  private getQueryDefEcommerceConfig(): any
  {
    return new UrlQueryDef().getRequestConfig(true);
  }


  /**
  * Method used to get the information related to the case stages
  * */
  private getAllCaseStagesToCreateAStage(shoppingCartResponse: ShoppingCartItem[]): void
  {
    if (this.caseId)
    {
      this.caseStageDataService.get(this.onGetQueryDefForCaseStages())
        .subscribe((response: any) =>
        {
          this.currentStages = response?.rows != null ? response?.rows : [];
          this.onCheckServicesAdditionalAligners(shoppingCartResponse);
        });
    }
  }

  public onGetQueryDefForCaseStages()
  {
    let queryDef = new UrlQueryDef();

    queryDef.filter = 'CaseId eq ' + this.caseId;
    queryDef.orderby = 'StageNumber';

    return queryDef;
  }
  /**
   * Method used to show the dialog
   * */
  public onOpenUpgradeProduct(): void
  {
    if (this.hasPendingPayment)
    {
      this.setInfoAlert("No puedes hacer un upgrade de productos debido a que tienes un pago pendiente");
      return;
    }

    if (!this.hasUnlimitedAligners)
    {
      this.upgradeProductDialog.show = !this.upgradeProductDialog.show;
    }
    else
    {
      this.setInfoAlert("No es posible hacer el upgrade del producto. Tu producto ya cuenta con alineadores ilimitados");
    }
  }
  /**
   * Method used to set the upgrade producs information
   * */
  public setProductsUpgrade(products: any): void
  {
    this.products = products;
    this.upgradeProduct = this.products.firstOrNull();
    this.setProductImage();
  }
  /**
   * Method used to change the service price dinamically
   * */
  public setProductImage()
  {
    this.productUpgradeImage = this.upgradeProduct?.images.firstOrNull().url ?? AltProductImagePath;
  }
  /**
   * Method used to tell the user to erase its shopping cart
   * */
  public showDeleteCart(): void
  {
    if (this.shoppingCartDataService.getCountItems() > 0)
    {
      this.confirmDeleteCurrentCart.show = !this.confirmDeleteCurrentCart.show;
    }
    else
    {
      this.makeChargeUpgrade();
    }
  }
  /**
   * Method used to charge the upgrade product!
   * */
  public makeChargeUpgrade(): void
  {
    this.confirmDeleteCurrentCart.show = false;
    this.shoppingCartDataService.onClearItems();
    //Make the charge object!
    let itemPrices: ItemPrices =
    {
      price: this.upgradeProduct.finalPrice,
      subtotal: this.upgradeProduct.finalPrice / (1 + IVA),
      shoppingDiscount: null,
      totalTax: (this.upgradeProduct.finalPrice / (1 + IVA) * IVA)
    };
    let additionalServices: ProductAdditionalServices =
    {
      addDentalMonitoring: false,
      addIsComplexCase: false,
      extraAlignersQuantity: 0,
    };
    let images: ServiceImage =
    {
      url: this.productUpgradeImage,
    };
    let newService: Service =
    {
      id: this.currentEntity.productId,
      name: "Upgrade de producto: " + this.upgradeProduct.name,
      itemPrices: itemPrices,
      images: images,
      idSetup: null,
      serviceProductUpgrade: {...this.upgradeProduct, orderDetailId: this.currentEntity.orderDetailId},
      serviceType: ServiceType.Upgrade,
      additionalServices: additionalServices
    };
    this.shoppingCartDataService.onAddItem(newService, 1);
    this.shoppingCartDataService.caseId = this.caseId;
    this.shoppingCartDataService.casePatientName = this.currentEntity.patientFullName;
    this.router.navigate(['/ecommerce/checkout']);
  }
  /**
 * Begins: Methods used to get the prescriptions!!!
 */
  public getCaseStages(): void
  {
    if (this.caseId)
    {
      this.prescriptionDataService.getPrescriptionsByCaseId(this.caseId).subscribe((response: any) =>
      {
        response;
      });
    }
  }
  // ********************************************************************************
  // #region Methods StartupInfo
  // ********************************************************************************
  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentCustomer = response.items.firstOrNull();
          if (currentCustomer)
          {
            AppClientContext.Instance.customerId = currentCustomer.id;
            this.currentCustomer = currentCustomer;

            this.getCase();

          }
        });
    }
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private getUserLoginFromCache(): boolean
  {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    return this.setSecurityToken(user);
  }

  private setSecurityToken(user: any): boolean
  {
    if (user && user.cacheToken)
    {
      // Remove Token
      AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

      // Append Token
      AppClientContext.Instance.headerValues.set(ECOMMERCE_USER_TOKEN, user.cacheToken);

      return true;
    }
    return false;
  }

  getAlignersResumeByCase(){
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;

    this.dataService.getAlignersResumeByCase(queryDef).subscribe(res=>{
      this.alignersResume = res;
    })
  }

  private addOrderHistory(statusData: any): void
  {
    let queryDef = new UrlQueryDef();

    this.orderHistoryDataService.insert(statusData, queryDef.getRequestConfig(true))
      .subscribe((response: any) =>
      {
      }, fail =>
      {
        this.setWarningAlert(fail.error.errorDetail.message);
      });
  }

  public onHandleCancelOrderClick() :void
  {
    this.confirmCancelOrderDialog.show=true;
  }

  public onCancelOrder() : void
  {
    const statusData =
    {
      orderId: this.casePurchaseorder.order.id,
      description: "Se canceló la orden de compra.",
      orderStatus: OrderStatus.Canceled,
    };
    const body: any = {
      "id": this.casePurchaseorder.order.id,
      "orderStatus": OrderStatus.Canceled,
    };

    this.orderDataService.updateStatus(body)
      .subscribe((res: any) =>
      {
        this.addOrderHistory(statusData);
        this.setInfoAlert("Se canceló la orden de compra exitosamente.");
        this.checkCasePurchasedOrders();
        this.confirmCancelOrderDialog.show = false;
      },
      fail =>
      {
        this.setWarningAlert(fail.error);
      });
  }

  showPaymentStatusAlert()
  {
    if(this.casePurchaseorder)
    {
      return this.casePurchaseorder.order.status == OrderStatus.Approved && this.casePurchaseorder.order.paymentStatus == OrderPaymentStatus.InProcess;
    }
    else
    {
      return false;
    }
  }

  public setComplexCase(event:any)
  {
    this.hasComplexCase = event;
  }

  public setDisableUpgradeButton(upgradeCostCalculated: any)
  {
    this.disableUpgradeButton = !upgradeCostCalculated;
  }

}
